module.exports = __webpack_public_path__ + "d67a803b3388b5b73200e6eec553f6fe.woff";